import React from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation, useParams } from "react-router-dom";

import Layout from "../../components/Layout";
import InfoFooter from "../../components/InfoFooter";
import useArticles from "../../hooks/useArticles";

// Navigating from the list passes the article in router state, so the page
// renders instantly. Opening the URL directly (or reloading) has no state,
// so the article is looked up by title from the API instead.
const Clanek = () => {
  const { articleTitle } = useParams();
  const location = useLocation();
  const passedPost = location.state?.post;

  const { articles, loading, error } = useArticles();

  const post =
    passedPost ||
    articles.find((item) => item.title === decodeURIComponent(articleTitle));

  if (!passedPost && loading) {
    return (
      <Layout>
        <div className="loader-container">
          <div className="loader" />
        </div>
      </Layout>
    );
  }

  if (!post) {
    return (
      <Layout>
        <Helmet title="Článek nenalezen | Optika Volyně" />
        <section className="article-post-body">
          <div className="article-error">
            <h1>Článek se nepodařilo najít</h1>
            <p>{error || "Tento článek už možná není aktuální."}</p>
            <Link className="btn" to="/novinky">
              Zpět na novinky
            </Link>
          </div>
        </section>
        <InfoFooter />
      </Layout>
    );
  }

  return (
    <Layout>
      <Helmet titleTemplate="%s | Optika Volyně">
        <title>{post.title}</title>
        <meta name="description" content={(post.content || "").slice(0, 160)} />
      </Helmet>
      <section className="article-post-body">
        <div className="container content">
          <div className="columns">
            <div>
              <h1 className="article-post-heading">{post.title}</h1>
              {post.date && <p className="article-date">{post.date}</p>}
              {post.imageUrl && (
                <img
                  className="article-post-image"
                  src={post.imageUrl}
                  alt={post.title}
                />
              )}
              {/* The sheet holds plain text; blank lines separate paragraphs. */}
              {(post.content || "")
                .split(/\n{2,}/)
                .filter((paragraph) => paragraph.trim())
                .map((paragraph, index) => (
                  <p key={index}>{paragraph.trim()}</p>
                ))}
              <br />
              <Link className="btn" to="/novinky">
                Zpět na novinky
              </Link>
            </div>
          </div>
        </div>
      </section>
      <InfoFooter />
    </Layout>
  );
};

export default Clanek;
